import { motion } from "framer-motion";
import { Heart, ShieldCheck, Truck } from "lucide-react";

const ITEMS = [
  { icon: Truck, title: "25,000+ Pincodes", text: "Express delivery across India in 2–6 days, from metros to mofussil towns.", testid: "trust-shipping" },
  { icon: ShieldCheck, title: "Secure UPI Payments", text: "Pay with GPay, PhonePe or Paytm through a safe, encrypted checkout.", testid: "trust-upi" },
  { icon: Heart, title: "Loved by Parents", text: "Rated 4.9/5 for softness, true-to-size fits and wash-after-wash durability.", testid: "trust-loved" },
];

export default function TrustGrid() {
  return (
    <section className="py-16 md:py-20" data-testid="trust-grid">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-12 grid sm:grid-cols-3 gap-5">
        {ITEMS.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="bg-white rounded-3xl p-6 border border-ink/5 hover:border-terracotta/40 hover:-translate-y-1 transition-all duration-300"
            data-testid={item.testid}
          >
            <div className="w-11 h-11 rounded-2xl bg-peach flex items-center justify-center mb-4">
              <item.icon className="w-5 h-5 text-terracotta" />
            </div>
            <h3 className="font-semibold text-ink">{item.title}</h3>
            <p className="text-xs text-charcoal leading-relaxed mt-2">{item.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
